/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";

import { theme } from "styles";
// components
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Button from "components/entrance/Button";
//assets
import LeftArrow from "assets/icons/left-arrow.svg";

const SEX_ARR = ["남자", "여자", "선택안함"];
const TITLE = {
  1: "이름을 입력해주세요",
  2: "출생연도를 입력해주세요",
  3: "성별을 입력해주세요",
};

const UserinfoTemplate = ({
  title,
  inputValue,
  inputValueChange,
  buttonOnClick,
  onClickBack,
  onChangeSex,
}) => {
  const navigate = useNavigate();
  const pageRef = useRef();
  const [height, setHeight] = useState(window.innerHeight);
  const [step, setStep] = useState(1);
  const [sex, setSex] = useState([true, false, false]);

  const [focused, setFocused] = useState(inputValue.map((v) => false));
  const onFocus = (i) => {
    setFocused((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? true : false))
    );
  };
  const onBlur = (i) => {
    setTimeout(() => {
      setFocused((previousValue) =>
        previousValue.map((v, idx) => (i === idx ? false : v))
      );
    }, 100);
  };

  useEffect(() => {
    return () => {
      setFocused([false, false]);
    };
  }, []);

  useEffect(() => {
    window.visualViewport.addEventListener("resize", (e) => {
      const pageHeight = e.target.height;
      setHeight(pageHeight + scrollY);
    });
    return;
  }, [focused]);

  const handleClickSex = (i) => {
    setSex((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? true : false))
    );
    onChangeSex(SEX_ARR[i]);
  };

  const handleClickBack = () => {
    if (onClickBack) {
      onClickBack();
      return;
    }
    navigate(-1);
  };
  const handleClickFooter = (i) => {
    if (step === 3) return;
    if (i === 1) {
      setStep(2);
    }
    if (i === 0) {
      setStep(3);
    }
  };
  const checkPwValidation = useMemo(() => {
    const [birthYear, name] = inputValue;
    let nameVal = false;
    let birthYearVal = false;
    if (name !== "") {
      nameVal = true;
    }
    if (
      birthYear.length === 4 &&
      parseInt(birthYear, 10) > 1900 &&
      parseInt(birthYear, 10) < new Date().getFullYear()
    ) {
      birthYearVal = true;
    }
    return [birthYearVal, nameVal];
  }, [inputValue]);

  return (
    <Wrapper ref={pageRef} height={height}>
      <WrapperTop>
        <WrapperHeader>
          <div onClick={handleClickBack}>
            <img src={LeftArrow} alt="back" />
          </div>
        </WrapperHeader>
        <Text fontSize="24px" fontWeight="700" lineHeight="30px">
          {TITLE[step]}
        </Text>
        <WrapperInput>
          <WrapperSex
            css={css`
              transition: all 0.5s;
              opacity: ${step === 3 ? 1 : 0};
              margin-bottom: ${step === 3 ? "16px" : 0};
              position: relative;
              z-index: 1;
            `}
          >
            <Text color="gray80" fontSize="14px" lineHeight="18px">
              성별
            </Text>
            <SelectTab>
              {SEX_ARR.map((value, i) => {
                return (
                  <Text
                    key={value}
                    color={sex[i] ? "gray100" : "gray20"}
                    fontWeight={sex[i] ? "600" : "400"}
                    lineHeight="24px"
                    css={css`
                      background: ${sex[i] ? "#fff" : "#f1f4fb"};
                    `}
                    onClick={() => handleClickSex(i)}
                  >
                    {value}
                  </Text>
                );
              })}
            </SelectTab>
          </WrapperSex>
          <TextField
            type="tel"
            maxLength="4"
            label="출생연도"
            placeholder="연도 4자리"
            value={inputValue[0]}
            onChange={inputValueChange[0]}
            autoFocus={step === 2}
            focused={focused[0]}
            onFocus={() => onFocus(0)}
            onBlur={() => onBlur(0)}
            validation={
              !checkPwValidation[0] &&
              inputValue[0].length === 4 && {
                color: "danger",
                text: "올바른 생년월일을 입력해주세요",
              }
            }
            css={css`
              transition: all 0.5s;
              opacity: ${step === 1 ? 0 : 1};
              margin-top: -74px;
              transform: ${step === 3 && `translateY(74px)`};
              margin-bottom: ${step !== 1 ? "16px" : 0};
              position: relative;
              z-index: 2;
            `}
          />
          <TextField
            pattern={false}
            maxLength="50"
            label="이름"
            placeholder="본인 이름"
            value={inputValue[1]}
            onChange={inputValueChange[1]}
            autoFocus={step === 1}
            focused={focused[1]}
            onFocus={() => onFocus(1)}
            onBlur={() => onBlur(1)}
            css={css`
              -webkit-transition: all 0.5s ease;
              -moz-transition: all 0.5s ease;
              -ms-transition: all 0.5s ease;
              -o-transition: all 0.5s ease;
              transition: all 0.5s ease;

              -webkit-transform: scale(1);
              -moz-transform: scale(1);
              -ms-transform: scale(1);
              -o-transform: scale(1);
              transform: scale(1);

              margin-top: -74px;
              transform: ${step === 1
                ? "translateY(0)"
                : `translateY(${(step - 1) * 74}px)`};

              position: relative;
              z-index: 3;
            `}
          />
        </WrapperInput>
      </WrapperTop>

      <WrapperBtm>
        {focused.filter((v) => v).length === 0 && step === 1 && (
          <Button
            color={checkPwValidation[1] ? "white" : "disable"}
            background={checkPwValidation[1] ? "primary100" : "gray5"}
            onClick={checkPwValidation[1] ? () => setStep(2) : () => {}}
          >
            {step < 3 ? "다음" : "확인"}
          </Button>
        )}
        {focused.filter((v) => v).length === 0 && step === 2 && (
          <Button
            color={checkPwValidation[0] ? "white" : "disable"}
            background={checkPwValidation[0] ? "primary100" : "gray5"}
            onClick={checkPwValidation[0] ? () => setStep(3) : () => {}}
          >
            {step < 3 ? "다음" : "확인"}
          </Button>
        )}
        {focused.filter((v) => v).length === 0 && step === 3 && (
          <Button
            color={
              checkPwValidation[0] && checkPwValidation[1] && step === 3
                ? "white"
                : "disable"
            }
            background={
              checkPwValidation[0] && checkPwValidation[1] && step === 3
                ? "primary100"
                : "gray5"
            }
            onClick={
              checkPwValidation[0] && checkPwValidation[1] && step === 3
                ? buttonOnClick
                : () => {}
            }
          >
            완료
          </Button>
        )}
        {focused.map(
          (v, i) =>
            v && (
              <div
                key={i}
                className="footer"
                onClick={
                  checkPwValidation[i] ? () => handleClickFooter(i) : () => {}
                }
                style={{
                  background: checkPwValidation[i]
                    ? theme.colors["primary100"]
                    : theme.colors["gray5"],
                }}
              >
                <Text
                  color={checkPwValidation[i] ? "white" : "disable"}
                  fontSize="18px"
                  lineHeight="24px"
                >
                  {step < 3 ? "다음" : "확인"}
                </Text>
              </div>
            )
        )}
      </WrapperBtm>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 20px 42px;
  background: #fff;
  height: ${(props) => `${props.height}px`};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;
  .footer {
    position: absolute;
    bottom: 0;
    width: 100vw;
    height: 56px;
    margin-left: -20px;
    padding: 16px 24px;
    text-align: center;
    background: ${theme.colors["primary100"]};
    z-index: 10;
  }
`;

const WrapperTop = styled.div`
  white-space: pre;
`;

const WrapperHeader = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  div {
    padding: 4px 20px 4px 0;
  }
`;
const WrapperInput = styled.div`
  margin-top: 32px;
`;

const WrapperBtm = styled.div`
  button {
    margin-top: 24px;
  }
`;

const WrapperSex = styled.div`
  height: 74px;

  ${(props) => props.css}
`;

const SelectTab = styled.div`
  height: 48px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

  background: #f1f4fb;
  border-radius: 8px;
  span {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
  }

  ${(props) => props.css}
`;

export default UserinfoTemplate;
